import React from 'react';
import { FormattedMessage } from 'react-intl';

import config from '../../config';
import { ExternalLink } from '../../components';
import phonePicto from '../../assets/phone-call.png';
import mailPicto from '../../assets/mail.png';

import css from './styles.css';

const ContactCard = () => {
  const phoneNumber = config.custom.supportPhoneNumber;
  const phoneNumberReadable = config.custom.supportPhoneNumberReadable;
  const mailContact = config.custom.mailContact;
  const startSupportHours = config.custom.supportHours.start; 
  const endSupportHours = config.custom.supportHours.end; 

  return (
    <div className={css.infoContainer}>
      <div className={css.infoBlock}>
        <div className={css.contactNumberPhone}>
          <img src={phonePicto} alt="phone call" className={css.contactIcon}/>
          <div className={css.contactNumberPhoneContent}>
            <a href={`tel:${phoneNumber}`}>{phoneNumberReadable}</a>
            <span>
                <FormattedMessage id="FAQ.contactPhone" 
                  values={
                    { start: startSupportHours,
                      end:  endSupportHours,
                    }}
                />
            </span>
          </div>
        </div>
        <div className={css.contact}>
          <img src={mailPicto} alt="send a mail" className={css.contactIcon}/>
          <ExternalLink href={`mailto:${mailContact}`} >
            <FormattedMessage id="FAQ.contact" />
          </ExternalLink>
        </div>
      </div>
    </div>
  )
};

export default ContactCard;



// WEBPACK FOOTER //
// ./src/components/ContactCard/index.js